export default __webpack_public_path__ + "static/media/UmaPicture.813d743a.jpg";